import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import { Modal } from "components/common/Modal";
import type { ChangePageScaleModalProps } from "./types";

export const ChangePageScaleModal = ({
  isOpen,
  onClose,
  onPickPoints,
  onResetToDetected,
  canResetToDetected,
}: ChangePageScaleModalProps) => {
  const { t } = useTranslation();

  const handlePickPoints = () => {
    onPickPoints();
    onClose();
  };

  const handleReset = () => {
    onResetToDetected();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <h2 className="text-lg font-semibold text-gray-900 mb-2">
        {t("smartSurveyor.pageCalibration.changeScaleModal.title")}
      </h2>
      <p className="text-sm text-gray-600 mb-6">
        {t("smartSurveyor.pageCalibration.changeScaleModal.description")}
      </p>
      <div className="flex justify-end gap-3">
        <Button variant="danger" onClick={onClose}>
          {t("smartSurveyor.common.cancel")}
        </Button>
        {canResetToDetected && (
          <Button variant="outline" onClick={handleReset}>
            {t("smartSurveyor.pageCalibration.resetToDetected")}
          </Button>
        )}
        <Button variant="primary" onClick={handlePickPoints}>
          {t("smartSurveyor.pageCalibration.changeScaleModal.pickPoints")}
        </Button>
      </div>
    </Modal>
  );
};
